<ng-container *ngIf="insight$ | async as insight">
    <div webAppInsightView [insight]="insight" (onError)="handleError($event)" class="h100 oa"></div>
</ng-container>
